import './OrderItemNew.css'
import React from 'react';

function OrderItemNew(props) {
    return (
        <div className='order-item-main'>
            {props.itemType === 'meal' ? 
                <div className='order-item-meal order-item'>
                    <div className={!props.isValid ? 'error-border' : null}>
                        <div className='order-name-price'>
                            {
                                props.isWorkerMeal ? <p>Worker Meal</p> : <p>Meal</p>
                            }
                            <div className='right-side'>
                                <p>{props.itemPrice.toFixed(2)}</p>
                                <button className='add-button' onClick={() => props.onAddItem(props.itemNum)}>+</button>
                                <button className='delete-button' onClick={() => props.onDelete(props.itemNum)}>x</button>
                            </div>

                        </div>
                        {
                            props.item.entrees.map((entree, i) => 
                                <div key={i} className='meal-item'>
                                    <p style={{textIndent: "2em"}}>Entree - {entree.item}</p>
                                    <button className='delete-meal-item-button delete-button' onClick={() => props.onDeleteMealItem(props.itemNum, entree.item, 'entree')} >x</button>
                                </div>)
                        }
                        {
                            props.item.sides.map((side, i) => 
                                <div key={i} className='meal-item'>
                                    <p style={{ textIndent: "2em" }}>Side - {side.item}</p>
                                    <button className='delete-meal-item-button delete-button' onClick={() => props.onDeleteMealItem(props.itemNum, side.item, 'side')} >x</button>
                                </div>)
                        }
                        {
                            props.item.extras ? props.item.extras.map((extra, i) =>
                                <div key={i} className='meal-item'>
                                    <p style={{textIndent: "2em" }}>Extra - {extra.item}</p>
                                    <button className='delete-meal-item-button delete-button' onClick={() => props.onDeleteMealItem(props.itemNum, extra.item, 'extra')}>x</button>
                                </div>) : null
                        }
                    </div>                    
                </div> 
                : <div className='order-item-alacarte order-item order-name-price'>
                    <p>{props.item.item}</p>
                    <div className='right-side'>
                        <p>{props.itemPrice.toFixed(2)}</p>
                        <button className='delete-button' onClick={() => props.onDelete(props.itemNum)}>x</button>
                    </div>
                    </div>}
        </div>       
    )
}

export default OrderItemNew;